<template>
  <div class="row">
    <div class="col-lg-12">
      <h1 class="page-header">Tags</h1>
      <div class="row">
        <div class="col-xs-12 col-sm-12">
          <list
            ref="vuetable"
            :show-empty="true"
            title="Listagem de Tags"
            api-url="tags/list"
            report-title="Tags"
            :fields="fields"
            :initial-page="pagina"
            :pageCollection="'tags'"
            :appendParams="filtros"
          >
            <template slot="filters">
              <div class="collapse" id="filtros">
                <div class="col-sm-4">
                  <label class="custom-font" for="DAD_DCNOME_filter"
                    >Descrição</label
                  >
                  <input
                    type="text"
                    v-model="TAG_DCTAG"
                    class="form-control"
                    name="DAD_DCNOME_filter"
                  />
                </div>
                <div class="col-xs-12">
                  <button
                    @click="consultar()"
                    class="btn btn-default margem-topo"
                    name="btnFiltrar"
                  >
                    <font-awesome-icon :icon="'filter'"></font-awesome-icon>
                    Filtrar
                  </button>
                  <button
                    @click="limpar()"
                    class="btn btn-default margem-topo"
                    name="btnLimpar"
                  >
                    <font-awesome-icon :icon="'eraser'"></font-awesome-icon>
                    Limpar Filtros
                  </button>
                </div>
              </div>
            </template>
            <template slot="actions">
              <router-link
                class="btn btn-default"
                :to="{ name: 'admin_tags_save' }"
              >
                <font-awesome-icon :icon="'plus'"></font-awesome-icon> Adicionar
              </router-link>
              <button
                class="btn btn-default"
                data-toggle="collapse"
                data-target="#filtros"
              >
                <font-awesome-icon :icon="'filter'"></font-awesome-icon> Filtros
              </button>
            </template>
            <template slot="rowrender" slot-scope="props">
              <div class="">
                <button
                  title="Editar"
                  type="button"
                  class="btn btn-primary"
                  @click="editar(props.rowData)"
                >
                  <font-awesome-icon :icon="'edit'"></font-awesome-icon>
                </button>
                <button
                  title="Excluir"
                  class="btn btn-danger"
                  @click="excluir(props.rowData)"
                >
                  <font-awesome-icon :icon="'trash'"></font-awesome-icon>
                </button>
              </div>
            </template>
          </list>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-font {
  font-size: 16px;
  color: #00615c;
}
</style>

<script>
import list from '@/components/common/DataTable'
import request from '@/request'
import modal from '@/components/common/Modal'

export default {
  name: 'tags',
  inject: ["showConfirm"],
  data() {
    return {
      fields: [
        {
          name: 'TAG_DCTAG',
          title: 'Nome',
          sortField: 'TAG_DCTAG',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center col-md-3',
          dataClass: 'text-center'
        }
      ]
    }
  },
  components: {
    list,
    modal
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  computed: {
    filtros() {
      const { TAG_DCTAG } = this
      return {
        TAG_DCTAG
      }
    },
    pagina: {
      get() {
        const { tags } = this.$store.state.vuetableState
        const { pagina } = tags
        return pagina
      },
      set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'tags',
          value: value
        })
      }
    },
    TAG_DCTAG: {
      get() {
        const { tags } = this.$store.state.vuetableState
        const { TAG_DCTAG } = tags.filtros

        return TAG_DCTAG
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'TAG_DCTAG',
          collection: 'tags',
          value: value
        })
        this.resetPageStore()
      }
    }
  },
  methods: {
    editar(data) {
      this.$router.push({
        name: 'admin_tags_save',
        params: { id: data.TAG_IDTAG, name: data.TAG_DCTAG }
      })
    },
    excluir(data) {
      var dt = this.$refs.vuetable
      data.type = 'TAG'

      var config = {
        title: 'Alerta',
        question: true,
        yes: () => {
          request.delete(
            data,
            () => {
              dt.refresh()
            },
            () => {
              console.log(
                'houve um error ao tentar excluir esta tag, por favor tente novamente mais tarde.'
              )
            }
          )
        }
      }
      this.showConfirm(
        'Deseja realmente deletar este item?',
        config
      )
    },
    consultar() {
      this.$refs.vuetable.refresh()
    },
    limpar() {
      this.TAG_DCTAG = ''
      this.$refs.vuetable.refresh()
    },
    resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'tags',
        value: 1
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/tags/index.vue